import React from 'react';
import {
    useTheme
} from "@mui/material";

const SemiCircularThumbIcon = ({ value = 1, maxValue = 1, size = 200, strokeWidth = 10 }) => {
    const theme = useTheme();
    const radius = (size - strokeWidth) / 2;
    const center = size / 2;

    // SVG arc calculation
    const angle = (-value / maxValue) * 180; // 0 to 180 degrees
    const radians = (angle * Math.PI) / 180;

    const thumbX = center + radius * Math.cos(Math.PI - radians);
    const thumbY = center + radius * Math.sin(Math.PI - radians);

    // Large arc flag based on progress > 50%
    const largeArcFlag = -value > 50 ? 1 : 0;

    // Path from left to current angle
    const pathD = `
    M ${center - radius},${center}
    A ${radius},${radius} 0 ${largeArcFlag} 1 ${thumbX},${thumbY}
  `;

    return (
        <svg
            width="100%"
            height="auto"
            viewBox={`0 0 ${size} ${center}`}
            style={{ maxWidth: size, overflow: 'visible' }}
        >
            {/* Trail */}
            <path
                d={`
          M ${center - radius},${center}
          A ${radius},${radius} 0 1 1 ${center + radius},${center}
        `}
                fill="none"
                stroke="#888"
                strokeWidth={strokeWidth}
            />
            {/* Progress Path */}
            <path
                d={pathD}
                fill="none"
                stroke={theme.palette.secondary.main}
                strokeWidth={strokeWidth}
            />
            {/* Thumb */}
            <circle
                cx={thumbX}
                cy={thumbY}
                r={6}
                fill="white"
                stroke={theme.palette.secondary.main}
                strokeWidth="2"
            />
        </svg>
    );
};

export default SemiCircularThumbIcon;
